import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { CertificateDoc, CERT_CSS } from "@/pages/MemberCertificate";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public print route for headless-Chrome PDF rendering / eFax of the certificate.
export default function PrintCertificate() {
  const q = new URLSearchParams(useLocation().search);
  const scope = q.get("scope") || "master";
  const memberId = q.get("member_id") || "";
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/certificate/data`, { params: { scope, member_id: memberId || undefined } });
        setData(r.data);
      } catch { /* leave blank */ }
    })();
  }, [scope, memberId]);

  if (!data) return <div style={{ padding: 40, fontFamily: "serif" }}>Loading…</div>;
  return (
    <div style={{ background: "#fff" }}>
      <div className="cm-print-area"><CertificateDoc data={data} /></div>
      <style>{CERT_CSS}</style>
    </div>
  );
}
